const DEV = process.env.NODE_ENV === 'development'

// 文件资源
const RESOURCE_PATH = {
  DEV: 'https://file.kinfriend.com',
  PROD: 'https://file.kinfriend.com'
}

// 请求前缀，上线后需要 nginx 配置接口转发前缀则配置 *_PROD 即可
const PROXY = {
  API_DEV: '/apiProxy',
  API_PROD: 'https://client.kinfriend.com',

  SSO_DEV: '/ssoProxy',
  SSO_PROD: 'https://client.kinfriend.com',

  RESOURCE_DVE: '/resourceProxy',
  RESOURCE_PROD: 'https://client.kinfriend.com'
}

module.exports = {
  // 当前环境
  DEV,

  // 文件资源前缀
  RESOURCE_PATH: DEV ? RESOURCE_PATH.DEV : RESOURCE_PATH.PROD,

  // 请求 Proxy
  API_PROXY: DEV ? PROXY.API_DEV : PROXY.API_PROD,
  SSO_PROXY: DEV ? PROXY.SSO_DEV : PROXY.SSO_PROD,
  RESOURCE_PROXY: DEV ? PROXY.RESOURCE_DVE : PROXY.RESOURCE_PROD
}
